<div style="width: 100%; height: 0px; position: relative; padding-bottom: 56.25%; text-align:left">
  <iframe class="streamable-embed" [src]="safeUrl" frameborder="0" scrolling="no" style="width: 100%; height: 100%; position: absolute;" allowfullscreen></iframe>
</div>